"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSeenNewsItemMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.updateSeenNewsItemMutation = (0, graphql_tag_1.default) `
  mutation UpdateSeenNewsItemMutation($id: [Int!]!) {
    updateSeenNewsItem(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=update-seen-news-item.js.map